/**
 * Copyright Mántum All Rights Reserved.
 */
import { SignalIcon, SignalSlashIcon } from '@heroicons/react/24/outline';

type PropTypes = {
    error?: boolean;
    onClick?: () => void;
    title?: string;
};

export default function Action(props: PropTypes) {
    return (
        <div title={props.title}>
            {props.error ? (
                <button
                    type='button'
                    onClick={props.onClick}
                    className='rounded p-2 hover:cursor-pointer hover:bg-gray-50 active:bg-gray-100'
                >
                    <SignalSlashIcon className='h-5 w-5 text-error' />
                </button>
            ) : (
                <button type='button' className='cursor-default rounded p-2'>
                    <SignalIcon className='h-5 w-5' />
                </button>
            )}
        </div>
    );
}
